module.exports = __webpack_public_path__ + "img/Chimie_Etudiante-1536x864.cdd1ff21.jpg";